import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './AuthService';
import { TokensService } from '../app/api/api/tokens.service';
import { of, catchError, map } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {

  const auth = inject(AuthService);
  const router = inject(Router);
  const tokensApi = inject(TokensService);

  const urlParams = new URLSearchParams(window.location.search);
  const hash = urlParams.get('hash');
  if (hash) {
    return true;
  }

  if (!auth.isLoggedIn()) {
    return router.parseUrl('/login');
  }

  // Double check session with Registry API
  return tokensApi.apiTokenValidateGet().pipe(
    map(() => true),
    catchError(() => {
      auth.logout();
      return of(router.parseUrl('/login'));
    }),
  );
};
